
<template>
  <div>
    <div class="form-group">
      <label class="control-label">{{$t('service.package.pkg_name')}}</label>
      <!-- <Select2
        :options="pkg_templates"
        @change="onSelectPackage"
      >
      </Select2>-->
      <select class="form-control" v-model="pkg_template_data.id" @change="onEmitSelectPackage">
        <option
          v-for="(option, index) in pkg_templates"
          :key="index"
          :value="option.id"
        >{{option.pkg_name}}</option>
      </select>
      <!-- <span v-if="false" class="help is-danger">
          <font color="red">Required</font>
      </span>-->

      <br />

      <!-- Dịch Vụ Cố Định (1 Tháng) -->
      <div class="box box-success box-solid">
        <div class="box-header with-border">
          <h3 class="box-title">{{$t('service.package.fixed_service')}}</h3>

          <!-- <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse">
              <i class="fa fa-minus"></i>
            </button>
          </div> -->
          <!-- /.box-tools -->
        </div>
        <!-- /.box-header -->
        <div class="box-body" style>
          <div v-if="pkg_tmpl.package_onemonth_elements.length == 0">{{$t('service.package.not_found_service')}}</div>
          <div class="service-container">
            <ul class="nav nav-stacked">
              <row v-for="(item, index) in pkg_tmpl.package_onemonth_elements" :key="index">
                  <span class="col-md-6">{{item.name}}</span>
                  <span class="col-md-6">
                    <span class="badge bg-green pull-right">{{f_formatNumber(f_calculatorPriceService(item.price, item.vat))}} VNĐ</span>
                  </span>
              </row>
            </ul>
          </div>
          <div></div>
        </div>
        <!-- /.box-body -->
      </div>
      <!-- end - Dịch Vụ Cố Định (1 Tháng) -->

      <!-- begin - Chi Tiết Dịch Vụ -->
      <div class="box box-warning box-solid" >
        <div class="box-header with-border">
          <h3 class="box-title">{{$t('service.package.pkg_other_details')}}</h3>
        </div>
        <!-- /.box-header -->
        <div class="box-body" style>
          <div><textarea disabled class="form-control" rows="5" v-model="pkg_tmpl.pkg_other_details"></textarea></div>
        </div>
        <!-- /.box-body -->
      </div>
      <!-- end - Chi Tiết Dịch Vụ -->

    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import utils from '@/lib/utils';
//import moment from "moment";
//import Select2 from '@/components/LTESelect2Input.vue'

export default {
  name: "LeaseBackBookingPackageView",
  props: {
    id: {
      type: Number,
      default() {
        return 0;
      }
    },
    pkg: {
      type: Number,
      default() {
        return 0;
      }
    }
  },
  data() {
    return {
      // all package in select box
      pkg_templates: [],
      // all package get from db
      pkg_templates_data: [],
      // package current
      pkg_template_data: {
        id: 0
      },
      pkg_tmpl: {
        package_onemonth_elements: [],
        package_oncetime_elements: [],
        pkg_other_details : ""
      },
      emitPackage: true
    };
  },
  watch: {
    id: function() {
      if (parseInt(this.id) !== 0) {
        this.getAptDetails(this.id)
      }
    },
    pkg: function() {
      if (parseInt(this.pkg) !== 0) {
        this.emitPackage = false
        this.pkg_template_data.id = this.pkg
        if (parseInt(this.id) !== 0) {
          this.getAptDetails(this.id)
        }
      }
    },
    APARTMENT_DETAIL_DATA: function() {
      let number_bedrooms = !utils.isNull(
        this.APARTMENT_DETAIL_DATA.bedroom_count
      )
        ? this.APARTMENT_DETAIL_DATA.bedroom_count
        : 0;
      let filter = {
        params: {
          bedrooms: number_bedrooms
        }
      };
      this.getPackages(filter)
    }
  },
  computed: {
    ...mapGetters([
      "APARTMENT_DETAIL_DATA"
    ])
  },
  methods: {
    ...mapActions("packageModule", [
      "GET_PACKAGE_OPTIONS"
    ]),
    ...mapActions([
      "GET_APARTMENT_DETAIL"
    ]),
    getPackages: function(filter) {
      this.GET_PACKAGE_OPTIONS({data: filter})
        .then(
          function(res) {
            let pkg_templates_data = res.data;
            let pkg_templates = [];
            if (pkg_templates_data.length == 0) {
              let item = {
                id: -1,
                pkg_name: this.$t("apartmentbookings.no_eligible_packages")
              };
              pkg_templates.push(item);
            } else {
              pkg_templates_data.forEach(v => {

                let item = {
                  id: v.id,
                  pkg_name: v.pkg_name
                };
                pkg_templates.push(item);
              });
            }

            // set all package for select box
            this.pkg_templates = pkg_templates;

            // set all package get form db
            this.pkg_templates_data = pkg_templates_data;
            if (parseInt(this.pkg) !== 0) {
              this.pkg_template_data.id = this.pkg
              this.onSelectPackage()
            }
          }.bind(this)
        )
        .catch(
          function(error) {
            let item = {
              id: -1,
              pkg_name: this.$t("apartmentbookings.no_eligible_packages")
            };
            pkg_templates.push(item);
          }.bind(this)
        );
    },
    onEmitSelectPackage: function() {
      this.emitPackage = true
      this.onSelectPackage()
    },
    onSelectPackage: function() {
      // search info package by pkg id (this.pkg_template_data.id) in this.pkg_templates_data
      // return object info package
      let pkg_template_filter = this.pkg_templates_data.filter(
        item => item.id == this.pkg_template_data.id
      )

      if (pkg_template_filter.length !== 0) {
        let pkg_template_data = pkg_template_filter[0]
        this.pkg_tmpl.pkg_other_details = pkg_template_data.pkg_other_details

        // get package_onemonth_elements: Fixed service (1 Month)
        // get package_oncetime_elements: Non fixed service(1 Times)
        let package_onemonth_elements = [];
        let package_oncetime_elements = [];
        pkg_template_data.package_elements.forEach(v => {
          let details = v.service_details;
          let priceAfterVAT = this.f_calculatorPriceService(details.price, details.vat)
          let item = {
            service: v.service,
            name: details.name,
            price: details.price,
            vat: details.vat,
            feegroup: details.feegroup,
            priceAfterVAT: priceAfterVAT,
            payment_duration_factor: pkg_template_data.payment_duration_factor,
            other_details: pkg_template_data.pkg_other_details
          };
          if (details.feegroup === 1) {
            package_onemonth_elements.push(item);
          } else {
            package_oncetime_elements.push(item);
          }
        });

        // set Fixed service (1 Month)
        this.pkg_tmpl.package_onemonth_elements = package_onemonth_elements;
        // set Non fixed service(1 Times)
        this.pkg_tmpl.package_oncetime_elements = package_oncetime_elements;
        if (this.emitPackage) {
          this.$emit("package-select", this.pkg_template_data.id);
          this.$emit("package-onemonth-elements", this.pkg_tmpl.package_onemonth_elements);
        }
        this.$emit("package-current-elements", this.pkg_tmpl.package_onemonth_elements);
      }
    },
    // format number
    f_formatNumber: function(n){
      return utils.formatNumber(n)
    },
    // calcalator price service (price, vat)
    f_calculatorPriceService: function(price, vat){
      let pricePercent = Math.round((price * vat) / 100)
      return price + pricePercent
    },
    getAptDetails: function(apt_id){
      const data = { id: this.id }
      this.GET_APARTMENT_DETAIL(data)
        .then(function(res) {})
        .catch(function(error) {
          let item = {
            id: -1,
            pkg_name: this.$t("apartmentbookings.no_eligible_packages")
          };
          pkg_templates.push(item);
        });
    }
  },
  mounted() {
    if (parseInt(this.id) !== 0) {
      this.getAptDetails(this.id)
    }
  },
  components: {
    //Select2
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-group.required .control-label:after {
  color: #d00;
  position: absolute;
  margin-left: 8px;
  margin-top: -3px;
  font-family: "FontAwesome";
  font-weight: normal;
  font-size: 9px;
  content: "\f069";
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/LeaseBackBookingPackageView.vue